import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { PageHero, CTASection } from "../components/sections";
import { Reveal } from "../components/common";
import { IMAGES, COMPANY } from "../data/site";
import Seo from "../components/Seo";
import { SEO } from "../data/seo";

const cards = [
  {
    tag: "Application SaaS",
    title: "Cleanéo",
    text: "Une plateforme web pour gérer votre activité de nettoyage et vos locations saisonnières. Planification, équipes, livrets d'accueil digitaux et bien plus.",
    image: IMAGES.laptop,
    to: "/nos-services/applications",
    cta: "Découvrir l'application",
    links: [
      { label: "Accéder à Cleanéo", href: COMPANY.cleaneo },
    ],
  },
];

export default function NosServices() {
  return (
    <div data-testid="nos-services-page">
      <Seo {...SEO.services} />
      <PageHero
        eyebrow="Nos services"
        title="Conciergerie, ménage &amp; <em style='color:var(--gold-2)'>solutions digitales</em>"
        sub="Tous les services Cleanova-Sud : ménage professionnel, gestion du linge, préparation des logements, applications et paniers d'accueil."
        image={IMAGES.bedroom}
      />

      <section className="section">
        <div className="container-x space-y-10">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 100}>
              <div className={`grid lg:grid-cols-2 gap-0 items-stretch svc-card ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
                <div className="overflow-hidden" style={{ minHeight: 340, direction: "ltr" }}>
                  <img src={c.image} alt={c.title} className="svc-img w-full h-full object-cover" style={{ minHeight: 340 }} />
                </div>
                <div className="p-10 flex flex-col justify-center" style={{ direction: "ltr" }}>
                  <span className="eyebrow">{c.tag}</span>
                  <h3 className="font-display text-4xl mt-3">{c.title}</h3>
                  <p className="mt-4 leading-relaxed" style={{ color: "var(--muted)" }}>{c.text}</p>
                  <Link to={c.to} className="inline-flex items-center gap-2 mt-6 text-sm font-medium uppercase tracking-wider" style={{ color: "var(--gold)" }}>
                    {c.cta} <ArrowRight size={15} />
                  </Link>
                  {c.links.length > 0 && (
                    <div className="flex flex-wrap gap-3 mt-6">
                      {c.links.map((l) => (
                        <a key={l.label} href={l.href} target="_blank" rel="noreferrer" className="btn btn-outline-dark text-xs">
                          {l.label} <ArrowUpRight size={14} />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
